import React from 'react';
import SettlementGroupForm from './widgets/SettlementGroupForm';

export default function AddSettlementGroupScreen() {
  return <SettlementGroupForm mode="create" />;
}
